import React, { useContext, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Outlet, useLocation } from "react-router-dom";
import { Link, useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import ListItemIcon from '@mui/material/ListItemIcon';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import HomeIcon from '@mui/icons-material/Home';
import Divider from '@mui/material/Divider';
import { Fragment } from "react";
import TagsIcon from '@mui/icons-material/Bookmarks';
import Popover from '@mui/material/Popover';
import Chip from '@mui/material/Chip';
import { MsalContext } from '../Contexts/MsalContext';
import { APIContext } from '../Contexts/APIContext';
import Grid from "@mui/material/Grid";
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import Skeleton from "@mui/material/Skeleton";
import ListItemButton from "@mui/material/ListItemButton";

const drawerWidth = '240px';

const styles = {
    selectedRoute: {
        borderLeft: 'solid 10px #1d8abf'
    }
}

export default function CallfinderNav() {
    const { msalFetch } = useContext(MsalContext);
    const { isAdmin, isQA, isTeamLeader, isQATeamLeader, setIsClient, setIsExec, setIsClientAIEnabled, setIsClientTranscriptsEnabled, setIsAdmin, setIsQA, setIsTeamLeader, setIsQATeamLeader, setIsDataDialler, get, setIsAgent, setIsRTM } = useContext(APIContext);
    const [clientList, setClientList] = useState<[any] | undefined>(undefined);
    const [selectedClient, setSelectedClient] = useState('');
    const [pbiClient, setPbiClient] = useState('');
    const [popover2, setPopover2] = useState<HTMLElement | null>(null);
    const [clientLogoFound, setClientLogoFound] = useState<boolean>(false);
    const [agentFeedbackCount, setAgentFeedbackCount] = useState<string>('');
    const [challengedFeedbackCount, setChallengedFeedbackCount] = useState<number>(0);
    const [qaFeedbackCount, setQAFeedbackCount] = useState<number>(0);
    const [qaiEscalationCount, setQaiEscalationCount] = useState<number>(0);
    const navigate = useNavigate();
    const [selectedRoute, setSelectedRoute] = useState<string>('');

    const urlQuery = new URLSearchParams(useLocation().search)
    const urlClient = urlQuery.get('client') ?? '';

    const [loadingChecks, setLoadingChecks] = useState<object>({
        client: false,
        rtm: false,
        qa: false,
        agent: false,
        teamLeader: false,
        qaTeamLeader: false,
        admin: false,
        clientList: false,
        isClientAiEnabled: false,
        isClientTranscriptsEnabled: false,
        dataDialler: false
    })

    useEffect(() => {
        setClientLogoFound(true);
        let path = window.location.pathname;
        if (path.includes('/SearchIndex/')) {
            path = path.replace('/SearchIndex/', '');
            setSelectedClient(decodeURI(path.split('/')[0]));
        }
        if (path.includes('/Report/')) {
            path = path.replace('/Report/', '');
            setPbiClient(decodeURI(path.split('/')[0]));
        }
        fetchData();
    }, []);

    useEffect(() => {
        let path = window.location.pathname;
        if (selectedClient !== '') {
            if (!path.includes('/SearchIndex/')) {
                navigate('./SearchIndex?client=' + encodeURIComponent(selectedClient));
            }
            navigate('SearchIndex?client=' + encodeURIComponent(selectedClient));
        }
    }, [selectedClient])
    useEffect(() => {
        let path = window.location.pathname;
        if (pbiClient !== '') {
            if (!path.includes('/Report/')) {
                navigate('./Report?client=' + encodeURIComponent(pbiClient));
            }
            navigate('Report?client=' + encodeURIComponent(pbiClient));
        }
    }, [pbiClient])

    const openPopover2 = (e) => setPopover2(e.currentTarget);
    const closePopover2 = () => setPopover2(null);

    const onClientSelect = (client: string) => {
        setSelectedRoute('')
        setSelectedClient(client);
        setClientLogoFound(true);
    }


    const handleRouteChange = (route: string) => {
        setSelectedRoute(route);
        setSelectedClient('');
    }

    const fetchData = () => {
        msalFetch('api/User/IsClient')
            .then(response => response.json())
            .then(data => {
                setIsClient(data);
                setLoadingChecks((prev) => ({ ...prev, client: true }));
            });

        msalFetch(`api/User/IsClientAIEnabled`)
            .then(response => response.json()).then(data => {
                setIsClientAIEnabled(data);
                setLoadingChecks((prev) => ({ ...prev, isClientAiEnabled: true }));
            })

        msalFetch('api/User/IsClientTranscriptsEnabled')
            .then(response => response.json())
            .then(data => {
                setIsClientTranscriptsEnabled(data.value);
                setLoadingChecks((prev) => ({ ...prev, isClientTranscriptsEnabled: true }));
            });

        msalFetch('api/User/IsRtm')
            .then(response => response.json())
            .then(data => {
                setIsRTM(data);
                setLoadingChecks((prev) => ({ ...prev, rtm: true }));
            });

        msalFetch('api/User/IsQA')
            .then(response => response.json())
            .then(data => {
                setIsQA(data);
                setLoadingChecks((prev) => ({ ...prev, qa: true }));
                if (data) {
                    get('Feedback', 'GetQAFeedbackCount', (data) => setQAFeedbackCount(data));
                }
            });

        msalFetch('api/User/IsAgent')
            .then(response => response.json())
            .then(data => {
                setIsAgent(data);
                setLoadingChecks((prev) => ({ ...prev, agent: true }));
            });

        msalFetch('api/User/IsDataDialler')
            .then(response => response.json())
            .then(data => {
                setIsDataDialler(data);
                setLoadingChecks((prev) => ({ ...prev, dataDialler: true }));
            });

        msalFetch('api/User/IsTeamLeader')
            .then(response => response.json())
            .then(data => {
                setIsTeamLeader(data);
                setLoadingChecks((prev) => ({ ...prev, teamLeader: true }));
                if (data) {
                    get('Feedback', 'GetTeamLeaderFeedbackCount', (data) => setAgentFeedbackCount(data));
                }
            });

        msalFetch('api/User/IsQATeamLeader')
            .then(response => response.json())
            .then(data => {
                setIsQATeamLeader(data);
                setLoadingChecks((prev) => ({ ...prev, qaTeamLeader: true }));
                if (data) {
                    get('Feedback', 'GetChallengedFeedbackCount', (data) => setChallengedFeedbackCount(data));
                    get('QaiScorecardChallenge', 'GetEscalationCount', (data) => setQaiEscalationCount(data.value));
                }
            });

        msalFetch('api/User/IsExec')
            .then(response => response.json())
            .then(data => setIsExec(data))

        msalFetch('api/User/IsAdmin')
            .then(response => response.json())
            .then(data => {
                setIsAdmin(data);
                setLoadingChecks((prev) => ({ ...prev, admin: true }));
                if (data) {
                    get('Feedback', 'GetChallengedFeedbackCount', (data) => setChallengedFeedbackCount(data));
                    get('Feedback', 'GetTeamLeaderFeedbackCount', (data) => setAgentFeedbackCount(data));
                    get('QaiScorecardChallenge', 'GetEscalationCount', (data) => setQaiEscalationCount(data.value));
                }
            });

        msalFetch('api/User/GetClientList')
            .then(response => response.json())
            .then(data => {
                setClientList(data);
                setLoadingChecks((prev) => ({ ...prev, clientList: true }));
                if (data === undefined || data.length < 1) {
                    msalFetch('api/User/GetClientsClient')
                        .then(res => res.json())
                        .then(resp => {
                            setClientList([resp]);
                            setSelectedClient(resp);
                            setPbiClient(resp);

                        })
                }
            });
    }

    const checkIfSelectedRoute = (routeName: string) => {
        if (selectedRoute === routeName) {
            return styles.selectedRoute
        }
        return {}
    }

    const homeClick = () => {
        setSelectedRoute('');
        setSelectedClient('');
    }

    const navButtonSkeleton = (height: string, key: number) => <Grid key={key} size={12} paddingBottom={0.5}>
        <Skeleton variant="rectangular" width="100%" height={height} />
    </Grid>

    return (
        <Box display="flex" height="100%">
            <Box width={drawerWidth} overflow="auto">
                <List style={{ paddingBottom: '0px' }}>
                    <ListItem style={{ justifyContent: 'center' }} >
                        {clientLogoFound &&
                            <Grid container>
                                <Grid>
                                    <img
                                        src={`https://agentdashboardblob.blob.core.windows.net/$web/Firestone/${urlClient}.png`}
                                        onError={() => setClientLogoFound(false)}
                                        style={{ maxHeight: "23px", maxWidth: "208px" }}
                                    />
                                </Grid>
                            </Grid>
                        }
                    </ListItem>
                    <ListItemButton
                        key={0}
                        component={Link}
                        to="./"
                        onClick={() => homeClick()}>
                        <ListItemIcon>
                            <HomeIcon />
                        </ListItemIcon>
                        <ListItemText disableTypography primary={<Typography variant="subtitle1" fontFamily="Lexend">Home</Typography>} />
                    </ListItemButton>
                    {
                        Object.values(loadingChecks).includes(false) ?
                            <>
                                <Grid container justifyContent="center" alignItems="center" >
                                    {[...Array(2)].map((_, index) => navButtonSkeleton("60px", index))}
                                    {[...Array(6)].map((_, index) => navButtonSkeleton("50px", index + 1))}
                                </Grid>
                            </>
                            :
                            <>
                                {isAdmin &&
                                    <ListItemButton
                                        key={1}
                                        component={Link}
                                        to="TagManagement"
                                        onClick={() => handleRouteChange('Tags Management')}
                                        sx={checkIfSelectedRoute('Tags Management')}>
                                        <ListItemIcon>
                                            <TagsIcon />
                                        </ListItemIcon>
                                        <ListItemText disableTypography primary={<Typography variant="subtitle1">Tags Management</Typography>} />
                                    </ListItemButton>
                                }
                                {isAdmin &&
                                    <ListItemButton
                                        key={2}
                                        component={Link}
                                        to="ScorecardManagement"
                                        onClick={() => handleRouteChange('Scorecard Management')}
                                        sx={checkIfSelectedRoute('Scorecard Management')}>
                                        <ListItemIcon>
                                            <TagsIcon />
                                        </ListItemIcon>
                                        <ListItemText disableTypography primary={<Typography variant="subtitle1">Scorecard Management</Typography>} />
                                    </ListItemButton>
                                }
                                {isAdmin &&
                                    <ListItemButton
                                        key={17}
                                        component={Link}
                                        to="ClientReportSelection"
                                        onClick={() => handleRouteChange('Client Report Selection')}
                                        sx={checkIfSelectedRoute('Client Report Selection')}>
                                        <ListItemIcon>
                                            <TagsIcon />
                                        </ListItemIcon>
                                        <ListItemText disableTypography primary={<Typography variant="subtitle1">Client Report Selection</Typography>} />
                                    </ListItemButton>
                                }
                                {isAdmin &&
                                    <ListItemButton
                                        key={3}
                                        component={Link}
                                        to="ClientInsights"
                                        onClick={() => handleRouteChange('Client Insights')}
                                        sx={checkIfSelectedRoute('Client Insights')}>
                                        <ListItemIcon>
                                            <TagsIcon />
                                        </ListItemIcon>
                                        <ListItemText disableTypography primary={<Typography variant="subtitle1">Client Insights</Typography>} />
                                    </ListItemButton>
                                }
                                <Divider />
                                {
                                    (isTeamLeader || isAdmin) &&
                                    <ListItemButton
                                        key={10}
                                        component={Link}
                                        to="Feedback"
                                        onClick={() => handleRouteChange('Agent Feedback')}
                                        sx={checkIfSelectedRoute('Agent Feedback')}>
                                        <ListItemText
                                            disableTypography
                                            primary={<Typography variant="subtitle1">Agent Feedback</Typography>} />
                                        <Chip label={agentFeedbackCount} />
                                    </ListItemButton>
                                }
                                <Divider />
                                {
                                    (isTeamLeader || isAdmin) &&
                                    <ListItemButton
                                        key={11}
                                        component={Link}
                                        to="TeamLeaderScorecards"
                                        onClick={() => handleRouteChange('Team Leader Scorecards')}
                                        sx={checkIfSelectedRoute('Team Leader Scorecards')}>
                                        <ListItemText disableTypography primary={<Typography variant="subtitle1">Ops Feedback</Typography>} />
                                    </ListItemButton>
                                }
                                <Divider />
                                {
                                    (isTeamLeader || isAdmin) &&
                                    <ListItemButton
                                        key={12}
                                        component={Link}
                                        to="TeamLeaderQaiChallenge"
                                        onClick={() => handleRouteChange('Qai Challenges')}
                                        sx={checkIfSelectedRoute('Qai Challenges')}>
                                        <ListItemText
                                            disableTypography
                                            primary={<Typography variant="subtitle1">Q-AI Challenges</Typography>} />
                                        <Chip label={qaiEscalationCount} />
                                    </ListItemButton>
                                }
                                <Divider />
                                {(isQATeamLeader || isAdmin) &&
                                    <ListItemButton
                                        key={13}
                                        component={Link}
                                        to="FeedbackChallenges"
                                        onClick={() => handleRouteChange('Feedback Challenges')}
                                        sx={checkIfSelectedRoute('Feedback Challenges')}>
                                        <ListItemText
                                            disableTypography
                                            primary={<Typography variant="subtitle1">Feedback Challenges</Typography>} />
                                        <Chip label={challengedFeedbackCount} />
                                    </ListItemButton>
                                }
                                <Divider />
                                {
                                    (isQA || isQATeamLeader || isAdmin) &&
                                    <ListItemButton
                                        key={14}
                                        component={Link}
                                        to="QaQaiChallenge"
                                        onClick={() => handleRouteChange('Qai Escalations')}
                                        sx={checkIfSelectedRoute('Qai Escalations')}>
                                        <ListItemText
                                            disableTypography
                                            primary={<Typography variant="subtitle1">Q-AI Escalations</Typography>} />
                                        <Chip label={qaiEscalationCount} />
                                    </ListItemButton>
                                }
                                <Divider />
                                {
                                    (isQA || isQATeamLeader || isAdmin) &&
                                    <ListItemButton
                                        key={15}
                                        component={Link}
                                        to="QAFeedback"
                                        onClick={() => handleRouteChange('QA Feedback')}
                                        sx={checkIfSelectedRoute('QA Feedback')}>
                                        <ListItemText disableTypography primary={<Typography variant="subtitle1">QA Feedback</Typography>} />
                                        <Chip label={qaFeedbackCount} />
                                    </ListItemButton>
                                }
                                <Divider />
                                <ListItemButton key={16} onClick={openPopover2}>
                                    <ListItemText disableTypography primary={<Typography variant="subtitle1">{selectedClient === '' ? 'Client' : selectedClient}</Typography>} />
                                    <ListItemIcon >
                                        {
                                            Boolean(popover2) ?
                                                <ArrowLeftIcon />
                                                :
                                                <ArrowRightIcon />
                                        }
                                    </ListItemIcon>
                                </ListItemButton>
                                <Popover
                                    id="render-props-popover"
                                    open={Boolean(popover2)}
                                    anchorEl={popover2}
                                    onClose={closePopover2}
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                >
                                    <List>
                                        {(clientList !== undefined ? clientList.map((client, index) => (
                                            <ListItemButton key={"client" + index} onMouseUp={onClientSelect.bind(null, client)} onClick={closePopover2} sx={{ '&:hover': { backgroundColor: '#ccccccb8' } }}>
                                                <ListItemText id={client} defaultValue={client} disableTypography primary={<Typography variant="subtitle1">{client}</Typography>} />
                                            </ListItemButton>
                                        )) : <Fragment />)}
                                    </List>
                                </Popover>
                                <Divider />
                            </>
                    }
                </List>
            </Box >
            <Box flex={1} overflow="auto" padding="8px">
                {
                    !Object.values(loadingChecks).includes(false) &&
                    <Outlet />
                }
            </Box>
        </Box >
    );
}